<template>
  <v-container>

    <NavBar :step="0" />

    <Titulo></Titulo>

    <br>
    <br>

    <v-stepper :class="vSteperStyle" v-model="e1" elevation="0">
      <v-stepper-header style="box-shadow: none">
        <v-stepper-step :complete="e1 > 1" step="1"> Inicio </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2"> Plan </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 3" step="3"> Mascotas </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4"> Datos </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <div class="step-data">

            <v-form ref="form" v-model="valid" max-witdh="300px">

              <h3 class="text-center"
                style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 22px; line-height: 26px;  letter-spacing: -0.01em; color: #2D387C; mix-blend-mode: darken;">
                ¡Hola!</h3>
              <h3 class="text-center"
                style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 18px; line-height: 15px; letter-spacing: -0.01em; color: #2D387C;">
                ¿Cómo te llamas?</h3>
              <br>

              <v-row>
                <v-col>
                  <v-text-field v-model="userData.name" :rules="nameRules" label="Nombre" required solo filled
                    maxlength="51" style="box-sizing: border-box; height: 57px; margin:auto;
                        background: #FFFFFF; border: 1.5px solid rgba(142, 142, 142, 0.2); box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
                        border-radius: 6px;"></v-text-field>
                </v-col>

                <v-col>
                  <v-text-field v-model="userData.surname" :rules="surnameRules" label="Apellido" maxlength="51"
                    required solo filled style="box-sizing: border-box; height: 57px;
                        background: #FFFFFF; border: 1.5px solid rgba(142, 142, 142, 0.2); box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08); margin:auto;
                        border-radius: 6px;"></v-text-field>
                </v-col>

              </v-row>

              <br>
              <br>

              <h3 class="text-center"
                style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 18px; line-height: 15px; letter-spacing: -0.01em; color: #2D387C;">
                ¿Quieres un descuento en tu tarifa?</h3>

              <h4 class="text-center"
                style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 13px; line-height: 16px; color: #232323; opacity: 0.75; padding: 2%;">
                Ingresa tu email y participa por un descuento en el precio de tu seguro</h4>

              <v-text-field v-model="userData.email" maxlength="51" :rules="emailRules"
                label="Ingresa tu correo electrónico" solo filled style="box-sizing: border-box; height: 57px;  margin:auto;
                        background: #FFFFFF; border: 1.5px solid rgba(142, 142, 142, 0.2); box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
                        border-radius: 6px;"></v-text-field>
              <br><br>

              <h3 class="text-center"
                style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 18px; line-height: 15px; letter-spacing: -0.01em; color: #2D387C;">
                ¿Cuantas mascotas quieres asegurar?</h3>

              <h4 class="text-center"
                style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 13px; line-height: 16px; color: #232323; opacity: 0.75; padding: 2%;">
                Podrás proteger hasta 5 perros y/o gatos.</h4>

              <div class="step-data">
                <v-row>
                  <v-col :cols="3" style="margin-right: 20px">
                    <div class="circle-container">
                      <button class="circle-button" @click.prevent="addPet(1)">
                        <v-icon style="color:white">mdi-minus</v-icon>
                      </button>
                    </div>
                  </v-col>
                  <v-col :cols="3">
                    <div class="number-container">
                      <div class="number-button">
                        {{ petData.cantPet }}
                      </div>
                    </div>
                  </v-col>
                  <v-col :cols="3" style="margin-left: 20px">
                    <div class="circle-container">
                      <button class="circle-button" @click.prevent="addPet(2)">
                        <v-icon style="color:white">mdi-plus</v-icon>
                      </button>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <!-- <br>
              <br> -->

              <!-- <h3 class="text-center"
                style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 18px; line-height: 15px; letter-spacing: -0.01em; color: #2D387C;">
                ¿Cuál es tu teléfono?</h3>

              <h4 class="text-center"
                style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 13px; line-height: 16px; color: #232323; opacity: 0.75; padding: 2%;">
                Así también podremos enviarte la información a tu celular.</h4>

              <v-row>

                <v-col class="text-center" style="display:flex; justify-content: center;">
                  <v-text-field v-model="prefijoTelefono" label="+569" disabled solo filled style="box-sizing: border-box; max-width: 65px; height: 57px;
                        background: #FFFFFF; border: 1.5px solid rgba(142, 142, 142, 0.2); box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
                        border-radius: 6px 0 0 6px; "></v-text-field>

                  <v-text-field v-model="userData.phoneNumber"  :rules="phoneRules" :counter="8"
                    maxlength="8" label="0 000 0000" required solo filled style="box-sizing: border-box; height: 57px; 
                        background: #FFFFFF; border: 1.5px solid rgba(142, 142, 142, 0.2); box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08); 
                        border-radius:0 6px 6px 0; "></v-text-field>
                </v-col>

              </v-row> -->

              <!-- <br>
              <br>

              <h3 class="text-center"
                style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 18px; line-height: 15px; letter-spacing: -0.01em; color: #2D387C;">
                ¿Cuál es tu fecha de nacimiento?</h3>

              <h4 class="text-center"
                style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 13px; line-height: 16px; color: #232323; opacity: 0.75; padding: 2%;">
                Es para recomendarte el mejor seguro y además
                saludarte el día de tu cumpleaños.</h4> -->

              <div class="step-data">

                <!-- <v-row v-if="screen < 800">

                  <v-col>
                    <v-select :rules="monthRules" style="max-width: 85px; height: 57px; background: #FFFFFF; border: 1.5px solid rgba(142, 142, 142, 0.2); box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
                      border-radius: 6px;" :items="months" v-model="month" :loading="loadingMonths"
                      v-on:change="getDays()" item-text="name" label="Mes" return-object required solo
                      filled></v-select>
                  </v-col>

                  <v-col>
                    <v-select :rules="dayRules" style="max-width: 85px; height: 57px; background: #FFFFFF; border: 1.5px solid rgba(142, 142, 142, 0.2); box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
                      border-radius: 6px;" :items="days" v-model="day" :loading="loadingDays"
                      :disabled="loadingDays || month === null" item-text="name" label="Día" return-object required solo
                      filled>
                    </v-select>
                  </v-col>

                  <v-col>
                    <v-select :rules="yearRules" style="max-width: 85px; height: 57px; background: #FFFFFF; border: 1.5px solid rgba(142, 142, 142, 0.2); box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
                      border-radius: 6px;" value="2022" :items="years" v-model="year" item-text="name" label="Año"
                      return-object required solo filled></v-select>
                  </v-col>

                </v-row>

                <v-row v-else>

                  <v-col>
                    <v-select :rules="monthRules" style="max-width: 160px; height: 57px; background: #FFFFFF; border: 1.5px solid rgba(142, 142, 142, 0.2); box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
                      border-radius: 6px;" :items="months" v-model="month" :loading="loadingMonths" v-on:change="getDays()"
                      item-text="name" label="Mes" return-object required solo filled></v-select>
                  </v-col>

                  <v-col>
                    <v-select :rules="dayRules" style="max-width: 160px; height: 57px; background: #FFFFFF; border: 1.5px solid rgba(142, 142, 142, 0.2); box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
                      border-radius: 6px;" :items="days" v-model="day" :loading="loadingDays" :disabled="loadingDays || month === null"
                      item-text="name" label="Día" return-object required solo filled>
                    </v-select>
                  </v-col>

                  <v-col>
                    <v-select :rules="yearRules" style="max-width: 160px; height: 57px; background: #FFFFFF; border: 1.5px solid rgba(142, 142, 142, 0.2); box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
                      border-radius: 6px;" value="2022" :items="years" v-model="year" item-text="name" label="Año" return-object required
                      solo filled></v-select>
                  </v-col>

                </v-row> -->

                <v-row justify="center">
                  <v-dialog v-model="dialog" width="600px">
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">Términos y Condiciones</span>
                      </v-card-title>
                      <v-card-text style="text-align: justify;">
                        Por este acto, y según lo dispuesto en la Ley N° 19.628 sobre Protección de la Vida Privada y 
                        sus modificaciones, autorizo expresamente a Southbridge Compañía de Seguros Generales S.A. para 
                        que haga tratamiento, almacene, transmita y comunique mis datos personales y la información que 
                        le he proporcionado voluntariamente, a su matriz, filiales, sociedades coligadas, empresas 
                        relacionadas, sociedades del Grupo Empresarial al que pertenece y terceros prestadores de servicios, 
                        estén ubicados dentro o fuera de Chile, con el propósito de que tanto Southbridge Compañía de Seguros 
                        Generales S.A. como dichas entidades i) me contacten y pongan a mi disposición, en la forma que estimen 
                        pertinente, la más completa información y oferta de sus productos y servicios; ii) procedan al almacenamiento 
                        y tratamiento de mis datos personales y de mi información personal para los objetivos del cumplimiento de este 
                        Contrato de Seguro; y iii) hagan efectivos el o los convenios que pudieren estar asociados a los seguros que he 
                        contratado. Además, por este acto, autorizo expresamente a que cualquier información, comunicación, declaración 
                        o notificación que debe efectuar Southbridge Compañía de Seguros Generales S.A. en virtud del presente contrato 
                        de seguros sea realizada a través de correo electrónico o de cualquier sistema de transmisión o registro digital 
                        de la palabra escrita o verbal o por cualquier otro medio de comunicación fehaciente. El asegurado declara que 
                        conoce, acepta y concuerda que cualquier transacción que se realice en este sitio bajo su Rut y numero de documento,
                        se entenderá y se reputará, para todos los efectos legales, como realizada por él mismo. En tal sentido, el 
                        asegurado se hace entera y totalmente responsable del uso y seguridad de su Rut y numero de documento, no 
                        cabiéndole a Southbridge Compañía de Seguros Generales S.A. ninguna responsabilidad por el uso indebido de la 
                        misma por un tercero distinto del asegurado. El asegurado se hace responsable por la veracidad de la información 
                        entregada para la contratación del seguro, liberando a Southbridge Compañía de Seguros Generales S.A. de responsabilidad 
                        por cualquier mal uso que hagan terceros de la información que Southbridge Compañía de Seguros Generales S.A. 
                        entregue exclusivamente a la persona del asegurable. 
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          style="box-sizing: border-box; padding: 12px 24px; gap: 10px; background: #FFB600; border: 2px solid #FFB600;
                                  border-radius: 8px; margin-top: -6%; font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 14px; line-height: 17px;
                                  letter-spacing: 0.02em; color: white; flex: none; order: 0; flex-grow: 0; margin:auto;"
                          elevation="0" text @click="dialog = false">
                          Aceptar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>


                <v-hover v-if="screen > 800">
                  <v-checkbox :rules="conditionsRules" required>
                    <template v-slot:label>
                      <p style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 12px; line-height: 143.34%; letter-spacing: -0.3px; color: #232323;
                              opacity: 0.8; text-align: justify; max-width: 400px; margin-top: 10%;" @click="change()">
                        Al ingresar tus
                        datos
                        y
                        hacer
                        clic en continuar aceptas que tu información sea utilizada para calcular tu estimación de prima,
                        recomendar un seguro y
                        poder comunicarnos contigo de acuerdo a nuestros nuestros <b><a style="color:#2D387C"
                            @click="dialog = true">Términos y Condiciones</a></b></p>
                    </template>
                  </v-checkbox>
                </v-hover>

                <v-hover v-else>
                  <v-checkbox :rules="conditionsRules" required>
                    <template v-slot:label>
                      <p style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 12px; line-height: 143.34%; letter-spacing: -0.3px; color: #232323;
                              opacity: 0.8; text-align: justify; margin-top: 20%;" @click="change()">Al ingresar tus
                        datos y hacer clic
                        en
                        continuar
                        aceptas que tu información sea utilizada para calcular tu estimación de prima, recomendar un
                        seguro y
                        poder comunicarnos contigo de acuerdo a nuestros nuestros <b><a style="color:#2D387C"
                            @click="dialog = true">Términos y Condiciones</a></b></p>
                    </template>
                  </v-checkbox>
                </v-hover>

              </div>

              <div class="button-container">
                <v-btn style="background-color: #2D387C; color: white; border-radius: 12px; width: 100%; height: 120%;"
                  @click="validate()">
                  Continuar
                </v-btn>
              </div>
            </v-form>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
// import dateService from "@/services/date.service.js";
// import yearService from "@/services/year.service.js";
// import ShieldService from "../services/shield.service";
import NavBar from "@/components/NavBar.vue";
import Titulo from "../components/Titulo.vue";
import CryptoJS from 'crypto-js'
// import swal from 'sweetalert';

// import Vue from "vue";
// import { VueReCaptcha } from 'vue-recaptcha-v3'
// const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;
// Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {
  name: "Step1",
  components: { NavBar, Titulo },
  data: () => ({
    version: null,
    secretKey: process.env.VUE_APP_CRYPT,
    e1: 1,
    userData: {
      name: null,
      surname: null,
      serialNumber: null,
      rut: null,
      region: null,
      commune: null,
      regionCode: null,
      comuneCode: null,
      address: null,
      addressNumber: null,
      addressDepto: null,
      email: null,
      phoneNumber: null,
      couponId: null,
      dates: null,
      day: null,
      month: null,
      year: null,
      stepId: null,
      coverType: null,
    },
    petData: {
      cantPet: 1,
      autoSelect: false,
      dataPet: [
        {
          species: null,
          breed: null,
          breedCode: null,
          petName: null,
          age: null,
          sex: null,
          hasMicrochip: false,
          breeds: null,
          plan: null,
          selectPlan: null,
          expansionPanel: 0,
        }
      ],
    },
    servicesData: {
      stepId: null,
      contactID: null,
      type: 'create',
    },

    dialog: false,
    screen: window.screen.width,
    // months: [],
    // days: ["Selecciona el mes"],
    // yars: [],
    // prefijoTelefono: null,
    activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
    valid: false,
    nameRules: [
      (v) => !!v || "El nombre es requerido",
      // (v) => !/^[0-9]*$/.test(v) || "Ingrese solo letras",
      // (v) => /^[a-zA-ZáéíóúüÜñÑ\s-]+$/.test(v) || "Ingrese solo letras",
      (v) => /^[a-zA-ZáéíóúüÜñÑ\s]+$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres"
    ],
    surnameRules: [
      (v) => !!v || "El apellido es requerido",
      (v) => /^[a-zA-ZáéíóúüÜñÑ\s-]+$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres"
    ],
    emailRules: [
      (v) => !v || /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(v) || "Ingrese un correo válido",
      (v) => !v || v.length <= 50 || "Debe ingresar máximo 50 caracteres"
    ],
    conditionsRules: [
      (v) => !!v || "Debe estar de acuerdo con los términos y condiciones",
    ],
    monthRules: [
      (v) => !!v || "El mes es requerido",
    ],
    dayRules: [
      (v) => !!v || "El día es requerido",
    ],
    yearRules: [
      (v) => !!v || "El año es requerido",
    ],
    birthRules: [
      (v) => !!v || "Debe Ingresar la edad de la persona de Mayor Edad",
      (v) => !isNaN(parseFloat(v)) && v >= 18 && v <= 79 || 'El rango de la persona de Mayor Edad debe ser entre 18 y 79 Años'
    ],
    phoneRules: [
      (v) => !!v || "El número telefónico es requerido",
      (v) => /^[0-9]*$/.test(v) || "Ingrese solo números",
      (v) => (!!v && v.length == 8) || "Ingrese un número válido",
    ],
  }),
  async mounted() {
    // this.getMonths();
    // this.getYears();
    // this.userData.stepId = localStorage.getItem('stepId')

    // const query = this.$route.query;
    //const userDataAux = localStorage.getItem('userData');
    // const servicesDataAux = localStorage.getItem('servicesData');

    // if (query.stepID) {
    //   const abandoned = await ShieldService.newGetStepAbandoned(query.stepID);

    //   this.userData = abandoned.userData;
    //   this.servicesData.stepId = abandoned._id;
    //   this.servicesData.type = 'update';

    //   const userDataLocal = JSON.stringify(this.userData);
    //   const servicesDataLocal = JSON.stringify(this.servicesData);

    //   const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
    //   const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();

    //   localStorage.setItem('userData', encryptedUserDataLocal);
    //   localStorage.setItem('servicesData', encryptedServicesDataLocal);

    // } else if (userDataAux) {
    //   const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
    //   const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
    //   this.userData = JSON.parse(decryptedDataUser);
    //   console.log("userData: ", this.userData);

    //   if (servicesDataAux) {
    //     const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
    //     const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
    //     this.servicesData = JSON.parse(decryptedServicesData);
    //     console.log("serivcesData: ", this.servicesData);
    //   }

    // } else {
    //   const userDataLocal = JSON.stringify(this.userData);
    //   const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
    //   localStorage.setItem('userData', encryptedUserDataLocal);
    // }

    const userDataAux = localStorage.getItem('userData');
    const petDataAux = localStorage.getItem('petData');

    if (userDataAux) {
      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
      // console.log("userData: ", this.userData);
    } else {
      const userDataLocal = JSON.stringify(this.userData);
      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      localStorage.setItem('userData', encryptedUserDataLocal);
    }

    if (petDataAux) {
      const bytesPetData = CryptoJS.AES.decrypt(petDataAux, this.secretKey);
      const decryptedDataPet = bytesPetData.toString(CryptoJS.enc.Utf8);
      this.petData = JSON.parse(decryptedDataPet);
      // console.log("petData: ", this.petData);
    } else {
      const petDataLocal = JSON.stringify(this.petData);
      const encryptedPetDataLocal = CryptoJS.AES.encrypt(petDataLocal, this.secretKey).toString();
      localStorage.setItem('petData', encryptedPetDataLocal);
    }


  },
  methods: {

    async validate() {
      if (this.$refs.form.validate()) {



        // const fechaActual = new Date();
        // var newDate = this.year.id + "-" + this.month.number + "-" + this.day.id
        // var diff = fechaActual.getFullYear() - this.year.id
        // if (diff < 18) {
        //   swal({
        //     title: "Atención!",
        //     text: "Para contratar este seguro, usted debe ser mayor de edad!",
        //     icon: "info",
        //     button: "De acuerdo",
        //   });
        // } else {
        // this.userData.dates = newDate

        const userDataLocal = JSON.stringify(this.userData);
        const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
        localStorage.setItem('userData', encryptedUserDataLocal);

        const petDataLocal = JSON.stringify(this.petData);
        // console.log("LA DATA", this.petData)
        const encryptedPetDataLocal = CryptoJS.AES.encrypt(petDataLocal, this.secretKey).toString();
        localStorage.setItem('petData', encryptedPetDataLocal);

        // var shieldRes;
        // if (this.userData.email && this.activeCampaingUse == 'TRUE') {
        //   const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);

        //   if (activeCampaingRes.data.data.meta.total == 1) {
        //     this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;
        //     await ShieldService.updateContactActiveCampain(this.userData, null, null, this.servicesData, 0);
        //   } else {
        //     shieldRes = await ShieldService.createContactActiveCampain(this.userData, this.servicesData);

        //     if (shieldRes.data.status == 'ok') {
        //       this.servicesData.contactID = shieldRes.data.data.contacts[0].id;
        //     }
        //   }

        // const servicesDataLocal = JSON.stringify(this.servicesData);
        // const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
        // localStorage.setItem('servicesData', encryptedServicesDataLocal);

        //}
        // this.$router.push({ path: '/mt/mascotas' })
        this.$router.push({ path: '/mt/planes' })
        // }
      }
    },
    // async getMonths() {
    //   this.loadingMonths = true;
    //   this.months = await dateService.getMonths();
    //   this.loadingMonths = false;
    // },
    // async getDays() {
    //   if (this.month) {
    //     this.loadingDays = true;
    //     this.day = null;
    //     this.days = await dateService.getDays(
    //       this.month.name
    //     );
    //     this.loadingDays = false;

    //   }
    // },
    // async getYears() {
    //   this.loadingYears = true;
    //   this.years = await yearService.getYears();
    //   this.loadingYears = false;
    // },
    prefijo() {
      this.prefijoTelefono = '+56'
    },
    async addPet(index) {
      if (index == 1) {
        if (this.petData.cantPet > 1) {
          this.petData.dataPet.splice(this.petData.cantPet - 1, 1)
          this.petData.cantPet--;
        }
      } else if (index == 2) {
        if (this.petData.cantPet < 5) {
          var petDataAux = {
            species: null,
            breed: null,
            breedCode: null,
            petName: null,
            age: null,
            sex: null,
            hasMicrochip: false,
            breeds: null,
            plan: null,
            selectPlan: null,
            expansionPanel: 0,
          }
          this.petData.dataPet.push(petDataAux)
          this.petData.cantPet++;
        }
      }
    },
    async change() {

      // reCaptcha v3 token
      // await this.$recaptchaLoaded();
      // const tokenStep = await this.$recaptcha('captchaToken');

      try {

        const servicesDataAux = localStorage.getItem('servicesData');

        if (servicesDataAux) {
          const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
          const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
          this.servicesData = JSON.parse(decryptedServicesData);
          // console.log("serivcesData: ", this.servicesData);
        }

        // var carro = await ShieldService.newCreateStep(this.userData, null, null, this.servicesData, 'Inicio', tokenStep);
        // this.servicesData.type = 'update';
        // this.servicesData.stepId = carro.data.data._id;

        const servicesDataLocal = JSON.stringify(this.servicesData);
        const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
        localStorage.setItem('servicesData', encryptedServicesDataLocal);

      } catch (error) {
        console.log("Cart Fail");
      }
    }
  },
};
</script>

<style lang="scss">
.step-date {
  max-width: 200px;
  align-items: center;
  display: flex;
  margin-left: 2rem;
  justify-content: center;

  .v-select {
    max-width: 150px;
  }
}

.form-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 800px;
}

html body div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap main.v-main div.v-main__wrap div.container div.v-stepper.v-sheet.theme--light.elevation-0 div.v-stepper__items div.v-stepper__content div.v-stepper__wrapper div.step-data form.v-form div.step-data div.v-input.v-input--has-state.theme--light.v-input--selection-controls.v-input--checkbox.error--text div.v-input__control div.v-messages.theme--light.error--text div.v-messages__wrapper div.v-messages__message {
  text-align: center;
  padding-bottom: 2%;
}

html body div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap main.v-main div.v-main__wrap div.container div.v-stepper.v-sheet.theme--light.elevation-0 div.v-stepper__items div.v-stepper__content div.v-stepper__wrapper div.step-data form.v-form div.step-data div.v-input.v-input--has-state.theme--light.v-input--selection-controls.v-input--checkbox.error--text div.v-input__control div.v-messages.theme--light.error--text div.v-messages__wrapper {
  text-align: center;
  padding-bottom: 2%;
}

// #app>div>main>div>div>div.v-stepper.v-stepper--alt-labels.v-sheet.theme--light.elevation-0>div.v-stepper__header>div:nth-child(1)>span {
//   width: 39.89px;
//   height: 40px;
//   font-size: 2rem;
//   margin-top: -8%;
//   font-family: 'Verdana';
//   font-style: normal;
//   font-weight: 600;
//   font-size: 18px;
//   line-height: 26px;
//   letter-spacing: -0.01em;
//   color: #FCFCFC;
// }

// #app>div>main>div>div>div.v-stepper.v-stepper--alt-labels.v-sheet.theme--light.elevation-0>div.v-stepper__header>div:nth-child(3)>span {
//   width: 39.89px;
//   height: 40px;
//   font-size: 2rem;
//   margin-top: -8%;
//   font-family: 'Verdana';
//   font-style: normal;
//   font-weight: 600;
//   font-size: 18px;
//   line-height: 26px;
//   letter-spacing: -0.01em;
//   color: #FCFCFC;
// }

// #app>div>main>div>div>div.v-stepper.v-stepper--alt-labels.v-sheet.theme--light.elevation-0>div.v-stepper__header>div:nth-child(5)>span {
//   width: 39.89px;
//   height: 40px;
//   font-size: 2rem;
//   margin-top: -8%;
//   font-family: 'Verdana';
//   font-style: normal;
//   font-weight: 600;
//   font-size: 18px;
//   line-height: 26px;
//   letter-spacing: -0.01em;
//   color: #FCFCFC;
// }

// #app>div>main>div>div>div.v-stepper.v-stepper--alt-labels.v-sheet.theme--light.elevation-0>div.v-stepper__header>div:nth-child(7)>span {
//   width: 39.89px;
//   height: 40px;
//   font-size: 2rem;
//   margin-top: -8%;
//   font-family: 'Verdana';
//   font-style: normal;
//   font-weight: 600;
//   font-size: 18px;
//   line-height: 26px;
//   letter-spacing: -0.01em;
//   color: #FCFCFC;
// }

.titulo {
  background-image: url("~@/assets/images/titulo2.png");
  max-width: 350px;
  height: 150px;
  margin: auto;
}

.v-input .v-label {
  font-size: 12px;
  color: #8E8E8E;
}

.step-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-weight: 500;
    text-align: center;
    color: #464e71;
    margin-bottom: 2rem;
  }

  h2 {
    font-weight: 500;
    color: #464e71;
    margin-bottom: 1rem;
  }

  p {
    text-align: center;
  }

  .back-container {
    width: 100%;
    align-items: flex-start;

    .back-button {


      &:hover {
        opacity: 1;
      }
    }
  }

  .button-container {
    text-align: center;
  }

  .forecast-selector {
    text-transform: uppercase;
    font-weight: 600;
    color: #464e71;
  }
}


.v-btn__content {
  padding: 0.75rem;
}

.number-container {
  // Boton de eliminar - circulo exterior
  width: 35px;
  height: 35px;
  // border-radius: 20px;
  // background-color: #4F74E3;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 0.1px solid #4F74E3;
  margin-top: 30%;
}

.number-button {
  // Boton de eliminar - circulo Helveticaior
  width: 30px;
  height: 30px;
  border-radius: 200px;
  // background-color: #4F74E3;
  // color: white;
  // border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  margin: auto;
}

.circle-container {
  // Boton de eliminar - circulo exterior
  width: 35px;
  height: 35px;
  border-radius: 20px;
  background-color: #4F74E3;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.1px solid #4F74E3;
  margin-top: 30%;
}

.circle-button {
  // Boton de eliminar - circulo Helveticaior
  width: 30px;
  height: 30px;
  border-radius: 200px;
  background-color: #4F74E3;
  color: white;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  margin: auto;
}

.circle-button v-icon {
  // Boton de eliminar - Medidas del minus
  width: 7px;
  height: 14px;
}

.v-stepper__header {
  // Stepper header - contenedor de steper completo
  box-shadow: none !important;
  align-items: center !important;
  align-items: initial !important;
  margin: auto !important;
  flex-wrap: nowrap !important;
  height: 45px;
  max-width: 68%;
}

.v-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
  border: none !important;
  /* Elimina la línea */
  margin: 0 10px;
  /* Espacio entre pasos */
}

.v-divider::before {
  content: '\003E' !important;
  /* Código de la flecha '>' */
  font-size: 24px !important;
  /* Tamaño del icono */
  color: #5C6670 !important;
  /* Color de la flecha */
  font-weight: 300 !important;
}

@media only screen and (max-width: 767px) {
  .v-divider::before {
    content: '\003E' !important;
    /* Código de la flecha '>' */
    font-size: 24px !important;
    /* Tamaño del icono */
    color: #5C6670 !important;
    /* Color de la flecha */
    font-weight: 300 !important;
    // height: 20px !important;
  }
}

.theme--light.v-stepper .v-stepper__step--active .v-stepper__label {
  text-shadow: 0px 0px 0px #4F74E3 !important;
}

.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
  color: #2183f3 !important;
}

.v-stepper__step {
  align-items: center;
  display: flex;
  flex-direction: row;
  // padding: 0px !important;
  position: relative;
}

.theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
  background: none;
  margin-left: -50px;
}
</style>